import { render, staticRenderFns } from "./Login.Join.vue?vue&type=template&id=2dd02faa&scoped=true"
import script from "./Login.Join.vue?vue&type=script&lang=js"
export * from "./Login.Join.vue?vue&type=script&lang=js"
import style0 from "./Login.Join.vue?vue&type=style&index=0&id=2dd02faa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd02faa",
  null
  
)

export default component.exports